import { render } from "./FilterAndKeywordPanel.vue?vue&type=template&id=24bdcc0d"
import script from "./FilterAndKeywordPanel.vue?vue&type=script&lang=js"
export * from "./FilterAndKeywordPanel.vue?vue&type=script&lang=js"

import "./FilterAndKeywordPanel.vue?vue&type=style&index=0&id=24bdcc0d&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__